
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpOnHorizontal as ObiPumpOnHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-on-horizontal.js';
 
 
 

 
 export const ObiPumpOnHorizontal = createComponent({
   react: React,
   tagName: 'obi-pump-on-horizontal',
   elementClass: ObiPumpOnHorizontalElement,
   events: {
     
   }
  });
 
 